import { CartValidationError, UpdateUwgFlagInput } from '@spa/generated/graphql/graphql';
import { createAction } from '@reduxjs/toolkit';

export interface ApiOrdersPlaceOrdersRequestedPayload {
  readonly actionId: number;
  readonly casCartId: string | null;
  readonly homeCartId: string | null;
  readonly parentActionId: number;
  readonly additionalData: { [key: string]: string | undefined };
  readonly emarsysParams: UpdateUwgFlagInput;
}
export const apiOrdersPlaceOrdersRequestedType = 'api/orders/placeOrders--requested';
export const apiOrdersPlaceOrdersRequested = createAction<ApiOrdersPlaceOrdersRequestedPayload>(
  apiOrdersPlaceOrdersRequestedType
);
export type ApiOrdersPlaceOrdersRequestedAction = ReturnType<typeof apiOrdersPlaceOrdersRequested>;

export type ApiOrdersGiftCardCancellationStatus = 'SUCCEEDED' | 'FAILED';

export interface ApiOrdersPlaceOrderResult {
  readonly validationErrors?: ReadonlyArray<CartValidationError> | null;
  readonly orderId: string | null;
  readonly action: ApiOrdersPlaceOrderAction | null;
  readonly error: string | null;
  readonly giftCardCancellation: ApiOrdersGiftCardCancellationStatus | null;
}

export interface ApiOrdersPlaceOrdersSucceededPayload {
  readonly casCartId: string | null;
  readonly homeCartId: string | null;
  readonly requestedActionId: number;
  readonly parentActionId: number;
  readonly casResult: ApiOrdersPlaceOrderResult | null;
  readonly homeResult: ApiOrdersPlaceOrderResult | null;
}
export const apiOrdersPlaceOrdersSucceededType = 'api/orders/placeOrders--succeeded';
export const apiOrdersPlaceOrdersSucceeded = createAction<
  ApiOrdersPlaceOrdersSucceededPayload,
  typeof apiOrdersPlaceOrdersSucceededType
>(apiOrdersPlaceOrdersSucceededType);
export type ApiOrdersPlaceOrdersSucceededAction = ReturnType<typeof apiOrdersPlaceOrdersSucceeded>;

export interface ApiOrdersPlaceOrderRedirectAction {
  readonly type: 'redirect';
  readonly url: string;
}

export interface ApiOrdersPlaceOrderDisplayKlarnaWidgetAction {
  readonly type: 'display-klarna-widget';
  readonly clientToken: string;
}

export type ApiOrdersPlaceOrderAction =
  | ApiOrdersPlaceOrderRedirectAction
  | ApiOrdersPlaceOrderDisplayKlarnaWidgetAction;

export interface ApiOrdersPlaceOrdersFailedPayload {
  readonly requestedActionId: number;
  readonly error: string;
  readonly parentActionId: number;
}
export const apiOrdersPlaceOrdersFailedType = 'api/orders/placeOrders--failed';
export const apiOrdersPlaceOrdersFailed = createAction<
  ApiOrdersPlaceOrdersFailedPayload,
  typeof apiOrdersPlaceOrdersFailedType
>(apiOrdersPlaceOrdersFailedType);
export type ApiOrdersPlaceOrdersFailedAction = ReturnType<typeof apiOrdersPlaceOrdersFailed>;
